import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { DICT } from "./dict";
import { DICT_EMPRESAS } from "./dictEmpresas";
import { DICT_INTERACCIONES } from "./dictInteracciones";
import { DICT_PRODUCTO } from "./dictProducto";
import { setNumberLocale } from "@/lib/demo/utils";

export const LANGS = [
  { id: "es", label: "ES" },
  { id: "pt", label: "PT" },
  { id: "en", label: "EN" },
  { id: "fr", label: "FR" },
];
const IDX = { pt: 0, en: 1, fr: 2 };
const ALL = { ...DICT, ...DICT_EMPRESAS, ...DICT_INTERACCIONES, ...DICT_PRODUCTO };
const KEY = "upv_lang";
const I18nContext = createContext(null);

const interp = (s, vars) => (vars ? s.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? "")) : s);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const s = localStorage.getItem(KEY);
    return LANGS.some((l) => l.id === s) ? s : "es";
  });
  setNumberLocale(lang);

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem(KEY, lang);
  }, [lang]);

  const t = useCallback((key, vars) => {
    const base = key.includes("|") ? key.split("|")[1] : key;
    const tr = lang === "es" ? base : ALL[key]?.[IDX[lang]] ?? base;
    return interp(tr, vars);
  }, [lang]);
  const L = useCallback((obj) => obj?.[lang] ?? obj?.es ?? "", [lang]);

  const value = useMemo(() => ({ lang, setLang, t, L }), [lang, t, L]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
